/**
 * Rakuten Tracking + UTM First/Last Touch — Captura e persistência
 * v6 — landing_time no relógio de Brasília, mantendo o formato .SSSZ
 *      (ex: 2026-07-08T14:54:30.985Z — hora local de Brasília, sufixo Z).
 *
 * O que faz:
 *  1. Persiste UTM FIRST-TOUCH (primeira campanha) — gravado uma vez, nunca sobrescrito.
 *  2. Persiste UTM LAST-TOUCH (campanha mais recente antes da compra).
 *  3. Mantém a captura Rakuten (cookie rmStoreGateway + atributos).
 *  4. Escreve tudo como atributos do carrinho numa ÚNICA chamada -> order.note_attributes.
 *
 * Chaves gravadas: first_utm_* / last_utm_* (visíveis no checkout),
 *                  rakuten_site_id / rakuten_landing_time / rakuten_cookie_value.
 */

(function () {
  "use strict";

  // ──────────────────────────────────────────────────────────────────────────
  // CONFIG
  // ──────────────────────────────────────────────────────────────────────────
  var UTM_KEYS = ["source", "medium", "campaign", "term", "content"];
  var FIRST_TOUCH_DAYS = 30;
  var LAST_TOUCH_DAYS = 30;
  var OVERWRITE_LAST_ON_DIRECT = false; // false = pró-afiliado

  var FIRST_PREFIX = "first_utm_";
  var LAST_PREFIX = "last_utm_";

  // Formato do landing_time / cookie Rakuten:
  //   "brasilia_z" -> 2026-07-08T14:54:30.985Z  (PADRÃO: relógio de Brasília, sufixo Z)
  //   "utc"        -> 2026-07-08T17:54:30.985Z  (UTC real)
  //   "brasilia"   -> 2026-07-08T14:54:30-03:00 (Brasília com offset explícito)
  var TIMESTAMP_MODE = "brasilia_z";

  // ──────────────────────────────────────────────────────────────────────────
  // Utilitários
  // ──────────────────────────────────────────────────────────────────────────
  function setCookie(name, value, days) {
    var exp = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name + "=" + encodeURIComponent(value) +
      "; expires=" + exp + "; path=/; SameSite=Lax";
  }

  function getCookie(name) {
    var re = new RegExp("(?:^|; )" +
      name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)");
    var m = document.cookie.match(re);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function parseJSON(str) {
    if (!str) return {};
    try { return JSON.parse(str); } catch (e) { return {}; }
  }

  function buildLandingTimestamp() {
    var now = new Date();
    var brasilia = new Date(now.getTime() - 3 * 60 * 60 * 1000); // desloca -3h

    if (TIMESTAMP_MODE === "brasilia_z") {
      // Relógio de Brasília, mantendo o formato ISO com milissegundos e "Z".
      return brasilia.toISOString(); // ex: 2026-07-08T14:54:30.985Z
    }
    if (TIMESTAMP_MODE === "brasilia") {
      var pad = function (n) { return n < 10 ? "0" + n : "" + n; };
      return brasilia.getUTCFullYear() + "-" + pad(brasilia.getUTCMonth() + 1) + "-" +
        pad(brasilia.getUTCDate()) + "T" + pad(brasilia.getUTCHours()) + ":" +
        pad(brasilia.getUTCMinutes()) + ":" + pad(brasilia.getUTCSeconds()) + "-03:00";
    }
    return now.toISOString(); // "utc": UTC real
  }

  var params = new URLSearchParams(window.location.search);

  // 1. UTMs da URL atual
  var currentUtm = {};
  var hasUtm = false;
  UTM_KEYS.forEach(function (k) {
    var v = params.get("utm_" + k);
    if (v) { currentUtm[k] = v; hasUtm = true; }
  });

  // 2. FIRST-TOUCH — grava só se ainda não existir
  var firstRaw = getCookie("_utm_first");
  if (hasUtm && !firstRaw) {
    firstRaw = JSON.stringify(currentUtm);
    setCookie("_utm_first", firstRaw, FIRST_TOUCH_DAYS);
    console.log("[UTM] First-touch registrado:", currentUtm);
  }

  // 3. LAST-TOUCH
  var lastRaw = getCookie("_utm_last");
  if (hasUtm) {
    lastRaw = JSON.stringify(currentUtm);
    setCookie("_utm_last", lastRaw, LAST_TOUCH_DAYS);
    console.log("[UTM] Last-touch atualizado:", currentUtm);
  } else if (OVERWRITE_LAST_ON_DIRECT && lastRaw) {
    lastRaw = "{}";
    setCookie("_utm_last", lastRaw, LAST_TOUCH_DAYS);
  }

  // 4. Rakuten
  var ranSiteID = params.get("ranSiteID");
  var rakutenAttrs = {};

  if (ranSiteID) {
    console.log("[Rakuten] ranSiteID capturado:", ranSiteID);

    var landingTimestamp = buildLandingTimestamp();
    var cookieValue = "ald:" + landingTimestamp + "|atrv:" + ranSiteID;

    setCookie("rmStoreGateway", cookieValue, 30);

    rakutenAttrs.rakuten_site_id = ranSiteID;
    rakutenAttrs.rakuten_landing_time = landingTimestamp;
    rakutenAttrs.rakuten_cookie_value = cookieValue;
  }

  // 5. Persistir no carrinho (uma chamada; no máx. 1x por sessão sem novo touch)
  var alreadySynced = sessionStorage.getItem("_utm_cart_synced") === "1";

  if (!firstRaw && !ranSiteID) return;
  if (alreadySynced && !hasUtm && !ranSiteID) return;

  var first = parseJSON(firstRaw);
  var last = parseJSON(lastRaw);

  var attributes = {};
  Object.keys(rakutenAttrs).forEach(function (k) {
    attributes[k] = rakutenAttrs[k];
  });
  UTM_KEYS.forEach(function (k) {
    attributes[FIRST_PREFIX + k] = first[k] || "";
    attributes[LAST_PREFIX + k] = last[k] || "";
  });

  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ attributes: attributes })
  })
    .then(function () {
      sessionStorage.setItem("_utm_cart_synced", "1");
      console.log("[UTM] Atributos gravados no carrinho:", attributes);
    })
    .catch(function (err) {
      console.debug("[UTM] Falha ao salvar atributos do carrinho:", err);
    });
})();